import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';

const PricacyPolicy = () => {
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>隱私政策</h2>
            <p><strong>Dreamehome隱私政策</strong></p>
            <p><strong>引言</strong></p>
            <p>
                “Dreamehome”業務是由追覓創新科技（蘇州）有限公司、及其關聯公司（以下稱“我們”或“追覓”）運營的，為您提供智慧硬體設備控制和管理服務的平臺（或服務）。我們理解並清楚個人資訊對您的重要性，並將盡全力保護您的個人資訊安全。我們將按業界公認的安全標準，採取相應的安全保護措施來保護您的個人資訊。
            </p>
            <p>因此，請您在使用我們的產品（或服務）前，仔細閱讀並瞭解本《Dreamehome隱私政策》。</p>
            <p>如您是未成年人，請在監護人同意的情況下使用本應用程式並同意相關應用程式服務條款。</p>
            <p>
                本隱私政策在制定時充分考慮到您的需求，您全面瞭解我們的個人資訊收集和使用慣例，同時確保您最終能掌握提供給我們的個人資訊，這一點至關重要。本隱私政策規定我們如何收集、使用、披露、處理和儲存您使用我們的App時提供給我們的資訊。我們將嚴格遵守本隱私政策來使用這些資訊。
            </p>
            <p>本隱私政策將幫助您瞭解以下內容：</p>
            <p>1、我們收集哪些資訊以及如何使用資訊</p>
            <p>2、我們如何使用 Cookie 和同類技術</p>
            <p>3、我們如何委託處理、共享、轉讓和公開披露您的個人資訊</p>
            <p>4、我們如何儲存和保護您的個人資訊</p>
            <p>5、您的權利</p>
            <p>6、資料跨境傳輸</p>
            <p>7、聯絡我們</p>
            <p>8、本隱私政策如何更新</p>
            <p>附表一：第三方SDK詳情</p>
            <p>
                最後，我們的目的是給予您最好的使用者體驗，如您對本隱私政策存在任何疑問，我們設立了專門的隱私處理部門和人員，您可以透過本隱私政策第七部分與之取得聯絡。我們將根據各國政策和法律規定的時間來給予回覆。如您不滿意我們的回覆，特別是當您認為我們的個人資訊處理行為損害了您的合法權益時，您還可以透過向有管轄權的法院提起訴訟、向政府監管機構投訴等外部途徑進行解決。
            </p>
            <p><strong>一、我們收集哪些資訊以及如何使用資訊</strong></p>
            <p>個人資訊是指以電子或者其他方式記錄的能夠透過資訊本身或透過關聯其他資訊後能夠識別特定個人的各種資料。</p>
            <p>
                個人敏感性資訊是指一旦洩露、非法提供或濫用可能危害人身和財產安全、極易導致個人名譽、身心健康受到損害或歧視性待遇等的個人資訊。包括但不限於身份證號碼、個人生物識別資訊、銀行帳號、財產資訊、行蹤軌跡、交易資訊、14歲以下（含）兒童的個人資訊等。
            </p>
            <p>我我們收集個人資訊的主要目的在於向您提供產品和/或服務，並且保證我們遵守適用的相關法律、法規及其他規範性文件。您有權自行選擇是否提供該資訊，但多數情況下，如果您不提供，我們可能無法向您提供相應的服務，也無法回應您遇到的問題。。
            </p>
            <p><strong>（一）Dreamehome基本服務收集和處理您個人資訊的情形</strong></p>
            <p><strong>（1） Dreamehome應用程式對智慧硬體裝置連線和管理</strong></p>
            <p>
                為了給您提供Dreamehome的服務，使您可以安全地連線、管理智慧硬體裝置，我們可能會收集您的Wi-Fi資訊、位置資訊、登入帳號資訊、手機相關資訊、智慧硬體裝置相關資訊，以及追覓帳號和智慧硬體裝置的關聯資訊。這些資訊將用於為您提供智慧硬體裝置快接、連線、發現附近裝置和裝置管理的功能。上述各項資訊，詳細列舉如下：
            </p>
            <p>
                登入帳號資訊：您的追覓帳號使用者名稱、密碼、暱稱、頭像、郵箱、手機號。其中使用者名稱、密碼、手機號、郵箱屬於個人敏感性資訊，收集此類資訊的目的是登入追覓帳號伺服器認證使用者身份，獲取Dreamehome帳號訪問伺服器的許可權。您輸入的帳號使用者名稱和登入密碼認證資訊將會加密傳輸到追覓帳號伺服器進行登入認證，
            </p>
            <p>手機相關資訊：硬體裝置標識(IMEI/OAID, Mac地址, Android
                ID)、手機型號、系統版本資訊、系統語言、手機所設定的國家或地區、手機螢幕尺寸及解析度、CPU及顯示裝置相關資訊。收集此類資訊的目的是為了使Dreamehome應用程式能夠連線智慧硬體裝置。</p>
            <p>
                智慧硬體裝置的資訊：智慧硬體裝置的名稱、型號、版本、生產廠家、裝置識別符號、MAC地址、IP地址、裝置執行狀態、自定義屬性、設定參數、業務事件和裝置控制及使用記錄。我們收集此類資訊的目的是連結智慧硬體裝置，對裝置進行控制和管理，以及設定裝置屬性和參數，檢視裝置工作狀態和歷史記錄。
            </p>
            <p><strong>（2） Dreamehome應用程式和智慧硬體裝置的升級：</strong></p>
            <p>
                為了使您持續享受最新的Dreamehome的服務，我們可能會使用您Dreamehome應用程式的版本資訊、手機型號用於為您提供Dreamehome應用程式的升級服務。同時，我們可能收集您已連線的智慧硬體裝置列表和版本號資訊，用於為您提供智慧硬體裝置的升級功能，以確保您可以使用最新版本的服務（包括韌體版本）。Dreamehome只提供智慧硬體裝置的升級途徑，智慧硬體裝置韌體版本由智慧硬體裝置的生產廠商提供，生產廠商對版本品質和升級結果負責。
            </p>
            <p>若您不提供這類資訊，將無法升級Dreamehome應用程式和智慧硬體裝置韌體的新版本。</p>
            <p><strong>（3）線上問題回饋：</strong></p>
            <p>
                為了幫助您更有效的解決Dreamehome應用程式、智慧硬體裝置可能出現的問題，我們提供給您線上問題反饋的方式，為了實現上述功能，我們需要收集您的以下資訊：Dreamehome應用程式和裝置的日誌資訊、您回饋的聯絡方式和問題描述、問題現象圖片及影片。其中應用程式和裝置的日誌資訊中會包含裝置狀態、感測器裝置感知到的資訊、裝置操作記錄、裝置識別符號等，收集此類資訊的目的是分析和定義問題原因；收集您的聯絡方式的目的是為了追蹤回訪，瞭解問題是否完全解決，或者與您聯絡，希望您補充必要的其他資訊。
            </p>
            <p>我們將按照以下方式使用您的個人資訊：僅用於回饋問題的定義與解決，不用於個人資訊的展示，不將此類資訊用於推送商業廣告。若您不提供這類資訊，將無法對您反饋的問題進行有效的定位和解決。</p>
            <p><strong>（二）我們在為您提供Dreamehome基本服務以外的收集和處理您個人資訊的情形</strong></p>
            <p>
                Dreamehome除基本服務會使用到您的個人資訊以外，我們的以下附加功能中也可能會收集和使用您的個人資訊。如果您不提供這些個人資訊，您依然可以使用Dreamehome的基本服務，但您可能無法使用這些可以為您所帶來便利的附加功能。這些附加功能包括：
            </p>
            <p><strong>使用者體驗改善計劃：</strong></p>
            <p>為改善使用者體驗，我們需要收集您的以下資訊：Dreamehome的日誌，其中包含經過加密處理後的關鍵流程日誌、事件日誌、故障日誌、業務事件、App各個介面的使用情況等，日誌中不會記錄您的敏感性資訊。</p>
            <p>我們將按照以下方式使用您的個人資訊：自動採集上述資訊並上傳到伺服器，分析日誌資訊診斷裝置執行狀態並分析App使用情況。</p>
            <p>如果您不提供這些資訊，Dreamehome將無法及時改善您的使用者體驗，但這並不會影響使用本服務的基本功能。</p>
            <p> <strong>（三）我們從第三方獲得您個人資訊的情形</strong></p>
            <p>在一些法律允許的情況下，我們可能從第三方處獲得您的個人資訊。例如：</p>
            <p>1、在您授權的前提下，在第三方智慧硬體裝置管理業務中，我們將與第三方服務供應商進行合作，其中涉及我們從第三方服務供應商處獲取您的個人資訊。在第三方裝置管理業務中，我們將在您連結第三方帳號的條件下獲取您的以下個人資訊：</p>
            <p>第三方帳號的資訊，包括您的暱稱、頭像，用於在Dreamehome應用程式中顯示；</p>
            <p>裝置及網路資訊，包括裝置識別符號、MAC地址、裝置序列號，用於識別當前所工作的裝置以及進行裝置安全控制。</p>
            <p>
                如我們在開展業務時需進行的個人資訊處理活動超出您原本向第三方服務提供商提供個人資訊時的授權同意範圍，我們將在處理您的該等個人資訊前，徵得您的明示同意。此外，我們也將會嚴格遵守相關法律法規的規定，並要求第三方服務提供商保障其提供的資訊的合法性。
            </p>
            <p><strong>（四）非個人資訊</strong></p>
            <p>
                我們還可能收集其他無法識別到特定個人的資訊（即不屬於個人資訊的資訊），例如您使用特定服務時產生的統計類資料，如使用者的操作行為（包括點選、頁面跳轉、瀏覽時間）。收集此類資訊的目的在於改善我們向您提供的服務。所收集資訊的類別和數量取決於您如何使用我們產品和/或服務。
                我們會將此類資訊彙總，用於幫助我們向客戶提供更有用的資訊，瞭解客戶對我們網站、產品和服務中的哪些部分最感興趣，以便我們最佳化我們的服務介面。就本隱私政策而言，彙總資料被視為非個人資訊。如果我們將非個人資訊與個人資訊結合使用，則在結合使用期間，此類資訊將被視為個人資訊。
            </p>
            <p><strong>二、我們如何使用 Cookie 和同類技術</strong></p>
            <p>為確保Dreamehome的正常運轉，我們會在您的裝置上儲存名為Cookie的小資料檔案。Cookie
                通常包含識別符號、站點名稱以及一些號碼和字元。藉助於Cookie，Dreamehome能夠儲存您的網站登入帳號、偏好等資料。
            </p>
            <p>
                我們不會將Cookie用於本宣告所述目的之外的任何用途。您可根據自己的偏好管理或刪除Cookie。但如果您這麼做，在某些情況下可能會影響您安全訪問Dreamehome，且可能在每一次訪問Dreamehome時都需親自更改使用者設定。
            </p>
            <p><strong>三、</strong><strong>我們如何委託處理、共享、轉讓和公開披露您的個人資訊？</strong></p>
            <p><strong>（一）委託處理</strong></p>
            <p>在一般情況下，追覓可能會委託其他公司代表我們處理您的個人資訊。例如代表我們與您聯絡、傳送電子郵件或者為您提供技術支援的公司，這些公司只能將您的個人資訊用於代表我們向您提供服務。</p>
            <p>我們會與被委託方簽署嚴格的保密協議或個人資訊處理條款，要求他們按照本隱私政策以及採取相關的保密和安全措施來處理個人資訊。</p>
            <p><strong>（二）共享</strong></p>
            <p>一般情況下，我們不會對外共享您的個人資訊，但以下情況除外：</p>
            <p>1、獲得您的明確同意後，我們會向您指定的第三方共享您授權範圍內的資訊；包括應您的請求，將您的智慧家居產品的資訊和配置等內容共享給您的親友，以幫助您的親友快速透過他們的終端裝置使用本軟體及服務。</p>
            <p>
                2、Dreamehome服務中部分服務內容由第三方服務提供商提供，為此我們需要向第三方服務提供商提供您的部分個人資訊，例如網站託管、資料分析、支付和信用卡處理、基礎設施供應、IT服務、客戶支援服務、電子郵件傳送服務以及其他類似服務，從而確保他們能夠為我們提供服務。
            </p>
            <p>3、向直接或間接為您提供智慧硬體裝置和/或您用來訪問和使用我們網站和服務的網路和系統的客戶以及其他業務合作伙伴披露您的個人資訊。</p>
            <p>
                4、當發生重組、合併、出售、合資、讓渡、轉讓或其他處置我們所有或部分業務、資產或股票（包括但不限於與任何破產或類似程式相關的上述情況）的情況時，向附屬公司或其他第三方披露您的個人資訊。在這種情況下，您將透過電子郵件和/或我們的網站收到關於所有權變更、個人資訊新的使用方式不相容以及有關個人資訊選擇的明確通知。
            </p>
            <p>
                5、在我們認為必要或適當的情況下：（a）遵守適用的法律法規；（b）遵守法律程序；（c）響應公共機構和政府當局的要求，包括您居住的國家/地區以外的公共機構和政府當局；（d）履行我們的條款和條件；（e）保護我們的運營、業務和系統；（f）保護我們和/或包括您在內的其他使用者的權利、隱私、安全或財產；以及（g）尋求可用的補救措施或限制我們可能需要提供的損害賠償。
            </p>
            <p>6、向公司旗下的子公司或附屬公司披露您的個人資訊，以定期開展業務活動。</p>
            <p>7、
                我們會透過應用程式程式介面（API）、軟體工具開發包（SDK）與第三方進行必要的資料共享，不同版本的第三方SDK會有所不同，一般包括第三方帳號登入類、分享類、第三方支付類、廠商推送類、統計類等，我們會對第三方進行嚴格的安全檢測並約定資料保護措施。附件一為我們授權接入的第三方SDK詳情，請仔細閱讀。我們的隱私政策不適用於第三方提供的產品或服務。當您使用這些產品或服務時，也可能收集您的資訊。因此，我們強烈建議您花時間閱讀該第三方的隱私政策，就像閱讀我們的政策一樣。我們不對第三方如何使用他們向您收集的個人資訊負責，也不能控制其使用。我們的隱私政策不適用透過我們的服務連結的其他網站。您需自行獨立判斷您與連結網站的互動行為。在您首次進入第三方頁面前，第三方服務提供商會向您展示相關的協議和隱私宣告，請您仔細閱讀這些協議和隱私宣告。
            </p>
            <p><strong>（三）轉讓</strong></p>
            <p>追覓不會將您的個人資訊轉讓給任何公司、組織和個人，但以下情況除外：</p>
            <p>1. 在獲取明確同意的情況下轉讓：獲得您的明確同意後，我們會向其他方轉讓您的個人資訊；</p>
            <p>2. 在涉及合併、收購或破產清算時，如涉及到個人資訊轉讓，我們會要求新的持有您個人資訊的公司、組織繼續受本宣告的約束，否則我們將要求該公司、組織重新向您徵求授權同意。</p>
            <p><strong>（四）公開披露</strong></p>
            <p>我們僅會在以下情況下，公開披露您的個人資訊：</p>
            <p>1、獲得您明確同意後；</p>
            <p>2、基於法律的披露：在符合法律或基於法律程序、訴訟或政府主管部門強制性要求的情況下，我們可能會公開披露您的個人資訊。</p>
            <p><strong>四、我們如何儲存和保護您的個人資訊 </strong></p>
            <p>
                我我們基於本隱私政策中所述的資訊收集的目的所必需的期間，或者遵守適用的相關法律要求保留個人資訊。個人資訊在完成收集目的，或在我們確認您的刪除或登出申請後，或我們終止運營相應產品或服務後，我們將停止保留，並做刪除或匿名化處理。如果是出於公眾利益、科學、歷史研究或統計的目的，我們將基於適用的法律繼續保留相關資料，即使進一步的資料處理與原有的收集目的無關。
            </p>
            <p>在Dreamehome業務中，您的個人資料具體保存時間如下：</p>
            <p>對於儲存在Dreamehome應用程式本地的資料，當您解除安裝Dreamehome應用程式或者清除Dreamehome應用程式資料時，所有儲存的資料將會被立即刪除。</p>
            <p>對於儲存在伺服器上的Dreamehome智慧硬體裝置和業務資料，當您刪除智慧硬體裝置、拒絕同意Dreamehome隱私政策並停止使用Dreamehome服務時，所有儲存的資料將會被立即刪除。</p>
            <p>對於儲存在伺服器上的業務日誌、統計資料和歷史記錄，我們會在不定期清理伺服器資料時刪除，資料儲存時間通常不長於2年。</p>
            <p>此外，當我們的產品或服務發生停止運營的情形時，我們將以推送通知、公告等形式通知您，並在合理的期限內刪除您的個人資訊或進行匿名化處理。</p>
            <p><strong>五、您的權利</strong></p>
            <p><strong>（一）訪問、更正、刪除您的個人資訊</strong></p>
            <p>根據您所適用的國家或地區法律法規，您有權要求訪問、更正、刪除我們持有的與您相關的任何個人資訊（以下簡稱請求）。請致信或者透過訪問Dreamehome聯絡我們。
                大多數法律要求個人資訊主體提出的請求應遵循特定要求，本隱私政策要求您的請求應當符合以下情形：</p>
            <p>透過我們專門的請求管道，並且出於保護您的資訊安全的考慮，您的請求應當是書面的（除非當地法律明確承認口頭申請）；</p>
            <p>提供足夠的資訊使我們可以驗證您的身份，確保請求人是所請求資訊主體本人或合法授權人；</p>
            <p>一旦我們獲得充分資訊確認可處理您的請求時，我們將在適用資料保護法律規定的時間內對您的請求做出回應。具體而言：</p>
            <p>基於您的要求及適用法律規定，我們可免費提供一份我們已收集並處理的關於您的個人資訊記錄，如您提出對於相關資訊的其他請求，我們可能會基於相關適用法律，並結合實際的管理成本向您收取一筆合理的費用。</p>
            <p>如果您認為我們持有的關於您的任何資訊是不正確或不完整的，可要求基於使用目的更正或完善個人資訊。</p>
            <p>
                根據您適用的法律法規，您可能有權要求我們刪除您的個人資料。我們將會根據您的刪除請求進行評估，若滿足相應規定，我們將會採取包括技術手段在內的相應步驟進行處理。當您或我們協助您刪除相關資訊後，因為適用的法律和安全技術，我們可能無法立即從備份系統中刪除相應的資訊，我們將安全地儲存您的個人資訊並將其與任何進一步處理隔離，直到備份可以清除或實現匿名。例如，根據《中華人民共和國電子商務法》，您的商品和服務資訊、交易資訊儲存時間自交易完成之日起不得少於三年。
            </p>
            <p>
                我們有權拒絕處理無實質意義/糾纏式重複的請求、損害他人隱私權的請求、極端不現實的請求，要求不相稱的技術工作，以及根據當地法律無需給予的請求，已經公之於眾的資訊，保密條件下給出的資訊。如果我們認為刪除資料或訪問資料的請求的某些方面可能會導致我們無法出於前述反欺詐和安全目的合法使用資料，可能也會予以拒絕。
            </p>
            <p><strong>（二）撤銷同意</strong></p>
            <p>
                您可以透過提交請求撤銷同意，包括收集、使用和/或披露我們掌握或控制的您的個人資訊。根據您所使用的具體服務，可以透過本隱私政策第七節中的聯絡方式聯絡我們進行相關操作。我們將會在您做出請求後的合理時間內處理您的請求，並且會根據您的請求，在此後不再收集、使用和/或披露您的個人資訊。
            </p>
            <p>請注意，根據您授權我們處理資訊的範圍，您撤銷同意可能導致您不能享受Dreamehome或其智慧硬體產品的服務。但您撤回同意或授權的決定，不會影響此前基於您的授權而開展的個人資訊處理。</p>
            <p>您可以訪問透過請求撤銷同意或進入Dreamehome頁面進行更改以退出使用者體驗改善計劃，撤回對此項個人資訊使用的同意。</p>
            <p><strong>（三）登出Dreamehome帳號</strong></p>
            <p>
                您可以透過訪問“我的”——“帳號設定”——“登出帳號”進行登出Dreamehome帳號。如您希望登出Dreamehome帳號，由於登出Dreamehome帳號的操作將使您無法使用Dreamehome及其全線智慧硬體產品和服務，請您謹慎操作。我們為了保護您或他人的合法權益會結合您對Dreamehome各智慧硬體產品和服務的使用情況判斷是否支援您的登出請求。
            </p>
            <p><strong>六、資料跨境傳輸</strong></p>
            <p>
                由於我們透過遍佈全球的資源和伺服器提供產品或服務，這意味著，在獲得您的授權同意後，您的個人資訊可能會被轉移到您使用產品或服務所在國家/地區的境外管轄區，或者受到來自這些管轄區的訪問。您的資訊可能傳輸到的國家/地區的資料保護措施和其他法律可能不像您所在國家/地區那樣全面。在此類情況下，我們將根據各個管轄區的適用法律採取適當以及合法的措施，以確保您的個人資訊繼續受到保護。
            </p>
            <p>特別說明：</p>
            <p>如果您是歐洲經濟區 (EEA) 居民，且您的個人資訊在 EEA
                境外傳輸，我們將：在歐盟委員會已確定可以提供足夠保護等級的區域處理您的個人資訊；或者實施適當的防護措施來保護您的個人資訊，包括按照適用的傳輸機制進行傳輸，例如歐盟委員會的標準合約條款。</p>
            <p><strong>七、聯絡我們</strong></p>
            <p>
                如果您對本隱私政策有任何意見或問題，或者您對我們收集、使用或披露您的個人資訊有任何問題，請透過下方地址或透過訪問“我的”——“關注與回饋”聯絡我們，並提及“隱私政策”。針對您關於個人資訊相關的權利請求、問題諮詢等時，我們有專業的團隊解決你的問題。如果你的問題本身涉及比較重大的事項，我們可能會要求你提供更多資訊。如果您對收到的答覆不滿意，您可以將投訴移交給所在司法轄區的相關監管機構。如果您諮詢我們，我們會根據您的實際情況，提供可能適用的相關投訴途徑的資訊。
            </p>
            <p>郵箱地址：</p>
            <ul>
                <li>中國區聯絡方式：<a className="page"
                    href="mailto:privacy@dreame.tech">privacy@dreame.tech</a> </li>
                <li>新加坡DPO聯絡方式：<a className="page"
                    href="mailto:dpo.sg@dreame.tech">dpo.sg@dreame.tech</a> </li>
                <li>歐盟代表聯絡方式：<a className="page"
                    href="mailto:representative.dreame@herrero.es">representative.dreame@herrero.es</a></li>
            </ul>
            <p>聯絡電話：400-875-9511</p>
            <p>網址：<a className="page"
                href="https://www.dreametech.com/ ">https://www.dreametech.com/ </a></p>
            <p><strong>八、本隱私政策如何更新</strong></p>
            <p>追覓保留適時更新本政策的權利，當政策發生變更時，我們會透過彈跳視窗方式或其他顯著的方式向您展示變更後的政策。只有在獲取您的同意後，我們才會按照更新後的政策收集、使用和儲存您的個人資訊。</p>
            <p>本政策自更新之日起生效。</p>
            <p>最近更新日期：2021年8月28日</p>
            <p>附表一：第三方<strong>SDK</strong>詳情</p>
            <p>*為了給您提供更專業、安全的基本和附加功能服務，Dreamehome會接入第三方SDK產品。目前Dreamehome中存在的第三方SDK產品披露如下：</p>
            <div className='tableStyle'>
                <table>
                    <tr>
                        <td>
                            <p>SDK服務</p>
                        </td>
                        <td>
                            <p>具體功能</p>
                        </td>
                        <td>
                            <p>獲取資訊</p>
                        </td>
                        <td>
                            <p>第三方隱私政策</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>友盟統計分析SDK</p>
                        </td>
                        <td>
                            <p>統計分析</p>
                        </td>
                        <td>
                            <p>裝置識別符號(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 資訊)、地理位置</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>友盟消息推送SDK</p>
                        </td>
                        <td>
                            <p>消息推送</p>
                        </td>
                        <td>
                            <p>裝置識別符號(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 資訊)、地理位置</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>友盟社會化分享SDK</p>
                        </td>
                        <td>
                            <p>第三方分享</p>
                        </td>
                        <td>
                            <p>裝置識別符號(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 資訊)、地理位置</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Agora SDK</p>
                        </td>
                        <td>
                            <p>連麥克風、影片流播放</p>
                        </td>
                        <td>
                            <p>裝置資訊、網路狀態、相機、麥克風、讀寫儲存空間</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.agora.io/cn/privacy-policy/">https://www.agora.io/cn/privacy-policy/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>華為推送SDK</p>
                        </td>
                        <td>
                            <p>推送</p>
                        </td>
                        <td>
                            <p>裝置標識資訊</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169">https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>小米推送SDK</p>
                        </td>
                        <td>
                            <p>推送</p>
                        </td>
                        <td>
                            <p>裝置標識資訊、裝置型號、網路型別、裝置儲存、裝置執行程序資訊、應用程式版本、SDK版本</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>OPPO推送SDK</p>
                        </td>
                        <td>
                            <p>推送</p>
                        </td>
                        <td>
                            <p>裝置標識資訊</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.oppomobile.com/wiki/doc#id=10194">https://open.oppomobile.com/wiki/doc#id=10194</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>VIVO推送SDK</p>
                        </td>
                        <td>
                            <p>推送</p>
                        </td>
                        <td>
                            <p>裝置標識資訊</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.vivo.com.cn/documentCenter/doc/366">https://dev.vivo.com.cn/documentCenter/doc/366</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>微信SDK</p>
                        </td>
                        <td>
                            <p>微信第三方登入、微信分享</p>
                        </td>
                        <td>
                            <p>裝置標識資訊、網路資訊</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>QQ SDK</p>
                        </td>
                        <td>
                            <p>分享</p>
                        </td>
                        <td>
                            <p>裝置標識資訊、網路資訊</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>微博SDK</p>
                        </td>
                        <td>
                            <p>微信第三方登入、微信分享</p>
                        </td>
                        <td>
                            <p>裝置標識資訊、網路資訊</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE">https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>AppleID SDK</p>
                        </td>
                        <td>
                            <p>使用Apple ID登入</p>
                        </td>
                        <td>
                            <p>Apple ID</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.Apple.com/legal/privacy/szh/">https://www.Apple.com/legal/privacy/szh/</a></p>
                        </td>
                    </tr>
                </table>
            </div>
            <div className='height'></div>

        </div>
    )
}

export default PricacyPolicy